// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mappings-rows{max-width:463px;width:463px}.mappings-rows .v-select__slot{padding-left:26px;padding-right:16px}.mappings-rows .v-select__selection--disabled{color:#000!important}.mappings-rows .v-input__control>.v-input__slot:after{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
